<script>
    export let data;

    import Button from '$lib/components/Button.svelte';

    const { product } = data;
</script>

<div class="flex flex-col gap-4">
    <h2 class="text-lg font-semibold dark:text-purple-300">Discontinued</h2>
    <p>{product?.title} by {product?.vendor} has been discontinued.</p>
    <p>We have plenty of other options similar to {product?.vendor}. Click the button below to browse our full product range!</p>
    <div>
        <Button style="Primary" href="/" title="Shop Caktus Vape">Shop Now</Button>
    </div>
</div>
